module.exports = __webpack_public_path__ + "static/crowd_alt-e1307c2b73b88fa3fe7b681e7a95d71e.jpg";